import { reactive } from 'vue'

const speakerModalState = reactive({
  show: false,
  speaker: undefined
})

export function useEvents () {
  return {
    speakerModalState
  }
}
